import React, { useState, useEffect, useContext } from 'react';
import './BillingSettings.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';

const BillingSettings = () => {
  const navigate = useNavigate();
  const { userId, token } = useContext(AuthContext);

  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // console.log('User ID:', userId);
  // console.log('Token:', token);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      // console.log('Fetching function is working');

      try {
        const response = await axios.get(
          `https://api.opencurtainscasting.com/payments/payby-details/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // console.log('API Response:', response.data);
        if (response.data.success && Array.isArray(response.data.result)) {
          setSubscriptionData(response.data.result);
        } else {
          console.error('Invalid API response format:', response.data);
          setError('Invalid data format.');
        }
      } catch (err) {
        console.error(
          'API Error:',
          err.response ? err.response.data : err.message
        );
        setError('Failed to load payment history.');
      } finally {
        setLoading(false);
      }
    };

    if (userId && token) {
      fetchPaymentHistory();
    }
  }, [userId, token]);

  const handleSubscribe = () => {
    navigate('/subscriptions');
  };

  const handleDeleteSubscription = async () => {
    if (!userId || !token) {
      console.error('User ID or token is missing.');
      return;
    }

    if (subscriptionData.length === 0) {
      alert('No active subscriptions to delete.');
      return;
    }

    const confirmDelete = window.confirm(
      'Are you sure you want to delete your subscription?'
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.post(
        'https://api.opencurtainscasting.com/payments/cancel-subscription',
        { userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // console.log('Cancel Response:', response.data);
      alert('Subscription deleted successfully.');
      setSubscriptionData([]);

      window.location.reload();
    } catch (err) {
      console.error(
        'Error deleting subscription:',
        err.response ? err.response.data : err.message
      );
      alert('Failed to delete subscription.');
    }
  };

  const hasSubscription = subscriptionData.length > 0;
  const hasNextPayment = subscriptionData.some((sub) => sub.nextPayDate);
  const hasActiveSubscription = subscriptionData.some(
    (sub) => ['active', 'trialing'].includes(String(sub.subStatus).toLowerCase())
  );
  const getDisplayPrice = (subscription) => {
    const paymentAmount = Number(subscription.paymentSummary?.amount);
    const fallbackAmount = Number(subscription.subscriptionpackage?.price);

    if (Number.isFinite(paymentAmount) && paymentAmount > 0) {
      return paymentAmount.toFixed(2);
    }

    if (Number.isFinite(fallbackAmount) && fallbackAmount > 0) {
      return fallbackAmount.toFixed(2);
    }

    return 'N/A';
  };

  return (
    <div className="billing-wrapper">
    <div className='billing-subscription-container'>
      <div className='subscription-table-container'>
        <h2 className='billing-title'>Subscription Details</h2>

        {loading ? (
          <p>Loading payment history...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : hasSubscription ? (
          <table className='billing-table'>
            <thead>
              <tr>
                <th>Plan Name</th>
                <th>Price</th>
                <th>Payment Method</th>
                <th>Subscription Date</th>
                <th>Next Payment Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {subscriptionData.map((sub, index) => (
                <tr key={index}>
                  <td>{sub.subscriptionpackage?.title || 'N/A'}</td>
                  <td>${getDisplayPrice(sub)}</td>
                  <td>Credit Card</td>
                  <td>{new Date(sub.createdAt).toLocaleDateString()}</td>
                  <td>
                    {sub.nextPayDate
                      ? new Date(sub.nextPayDate).toLocaleDateString()
                      : 'One-time payment'}
                  </td>
                  <td>{sub.subStatus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No subscriptions found.</p>
        )}
      </div>

      {hasActiveSubscription ? (
        <div className='billing-subscribe-box'>
          <div className='billing-subscribe-header'>
            <h3>Delete Existing Subscription</h3>
          </div>
          <p className='billing-subscribe-text'>
            Cancel your current subscription to stop further billing.
          </p>
          <button
            className='billing-subscribe-btn'
            onClick={handleDeleteSubscription}
            style={{ backgroundColor: 'red', color: 'white' }}
          >
            DELETE SUBSCRIPTION
          </button>
        </div>
      ) : null}

      {!hasActiveSubscription && (
        <div className='billing-subscribe-box'>
          <div className='billing-subscribe-header'>
            <h3>Subscribe Now</h3>
          </div>
          <p className='billing-subscribe-text'>
            Get full access and start applying to amazing jobs in show business!
          </p>
          <button className='billing-subscribe-btn' onClick={handleSubscribe}>
            SUBSCRIBE
          </button>
        </div>
      )}
    </div>
    </div>
  );
};

export default BillingSettings;
